import React from 'react'
import styled from 'styled-components'
import { Spinner } from '../../components/Spinner/Spinner'

const StyledSearching = styled.div`
  padding: 15rem 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
`

const StyledSpinner = styled(Spinner)``

const Searching = () => (
  <StyledSearching>
    <StyledSpinner />
  </StyledSearching>
)

export { Searching }
